// import './wdyr';

import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './App.css';
import './App.scss';
import './index.css';
import { initAccount, msalInstance } from './modules/auth';
// import store from './Store';
import store from './modules/core/store';
import * as serviceWorker from './serviceWorker';
import { patrimoniumTheme } from './ui/old/themes/patrimoniumTheme';

initAccount();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
        <MsalProvider instance={msalInstance}>
                <Router>
                    <ThemeProvider theme={patrimoniumTheme}>
                        <App />
                    </ThemeProvider>
                </Router>
            </MsalProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
